import React, { useEffect, useState } from 'react'
import '../../cssHelper/helper.css'
import './SearchResults.css'
import { useSelector } from 'react-redux';
import { apiKey, baseUrl } from '../../Constants/Constants'
import { useNavigate } from 'react-router-dom';

function SearchResults() {
    const navigate = useNavigate();
    const query = useSelector((state) => state.youtube.query)
    const [searchResults, setSearchResults] = useState();
    const setId = (id) => {
        navigate(`/watch?v=${id}`)
    }

    console.log(query);

    useEffect(() => {
        if (query != '') {
            fetch(`https://youtube.googleapis.com/youtube/v3/search?part=snippet&maxResults=50&q=${query}&key=${apiKey}`)
                .then(result => result.json())
                .then(data => {
                    console.log(data);
                    setSearchResults(data.items)
                })
                .catch(err => console.log(err));
        }
    }, [query])
    return (
        <div className="Search-wrapper scroll-y scroll-hidden-x w-full flex flex-col p-inline-3 pb-1 gap-1">
            {
                searchResults && searchResults.length > 0 ? (
                    searchResults.map((result) => (
                        <div onClick={() => setId(result.id.videoId)} className="result-item w-full flex gap-2 a-center">
                            <img src={result.snippet.thumbnails ? result.snippet.thumbnails.high.url : ''} alt="" className="result-thumbnail cover h-full r-7" />
                            <div className="result-details h-full flex flex-col">
                                <p className="bold-500 result-title">
                                    {result.snippet.title}
                                </p>
                                <div className="views flex font-xs a-center" style={{ marginTop: '0.2rem' }}>
                                    <span>10</span>
                                    <span>M</span>
                                    <span>views</span>
                                    <span>2</span>
                                    <span>Weeks</span>
                                    <span>ago</span>
                                </div>
                                <div className="flex gap-05 mt-1 a-center">
                                    <img src={result.snippet.thumbnails ? result.snippet.thumbnails.high.url : ''} alt="" className="cover img-3 r-50" />
                                    <span>
                                        {result.snippet.channelTitle}
                                    </span>
                                </div>
                                <p className="desctiption-result font-xs mt-1">
                                    {result.snippet.description}
                                </p>
                                <div className="promoted flex a-center mt-1">
                                    <div className="promote font-xs r-3">
                                        New
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))
                ) : ''
            }
        </div>
    )
}

export default SearchResults
